import { TestCardBase } from "@app/provider/testData/testCard/TestCardBase";
import { PrimaryAction, TestCard } from "@app/provider/testData/types";
import { IntlShape } from "react-intl/src/types";
import { Utils } from "@natera/material/lib/date";
import { getEstimatedResultsDeliveryDate } from "@app/utils";
import { messages } from "@app/provider/testData/messages";

export abstract class OrganHealthTestCardBase extends TestCardBase {
  protected getDescriptionForSamplesReceived(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    return undefined;
  }

  protected getDescriptionForSampleReceived(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    if (testCard.sampleReceivedDate) {
      const estimatedResultsDeliveryDate = Utils.getUSLocaleDate(
        getEstimatedResultsDeliveryDate(
          testCard,
          new Date(testCard.sampleReceivedDate),
          testCard.isSignateraSubsequent
        )
      );
      return intl.formatMessage(messages.testCardDescSampleReceived, {
        estimatedResultsDate: estimatedResultsDeliveryDate,
      });
    }
    return intl.formatMessage(messages.testCardDescSample);
  }

  protected getPrimaryActionForUpcomingTest(
    testCard: TestCard
  ): PrimaryAction | undefined {
    return undefined;
  }

  protected getPrimaryActionForTestOrdered(
    testCard: TestCard
  ): PrimaryAction | undefined {
    return undefined;
  }
}
